import { IDialogAction } from './IDialogAction';
import { DialogSignalRService } from '../services/DialogSignalRService';
import { DialogState } from '../models/DialogState';

export const ADD_BOOKMARK = 'ADD_BOOKMARK';

export class AddBookmarkAction implements IDialogAction {
    public readonly type = ADD_BOOKMARK;
    public constructor(public payload: any, private _service?: DialogSignalRService) {}
    public middleware(): any {
        if(this._service) {
            this._service.setReadLater(this.payload.id, true);
        }
        return;
    }
    public reducer(state: DialogState): DialogState {
        state.feed.messages.filter(m => m.id === this.payload.id).forEach(m => { m.readItLater = true; });
        return state;
    }
}

export const AddBookmarkActionTypeMapping = {
    [ADD_BOOKMARK]: AddBookmarkAction
};